export enum DecisionReviewAttributesId {
  Retained = 568,
  Lost = 569,
}
